export default __webpack_public_path__ + "static/media/seller-registration.99c2b42c.png";